import {useState, useEffect} from "react";
import {Link} from "react-router-dom";
import {getFromApi, patchToApi, deleteFromApi} from "../api/auth";
import AddNoteFolder from "../components/notes/AddNoteFolder";
import InlineRename from "../components/shared/InlineRename";
import ConfirmButton from "../components/shared/ConfirmButton";

export default function Notes() {
    const [allNotes, setAllNotes] = useState([]);
    const [search, setSearch]     = useState("");

    const load = async () => {
        const data = await getFromApi("api/notes/get-all");
        setAllNotes(data.data || []);
    };

    useEffect(() => { load(); }, []);

    const handleRename = async (id, name) => {
        await patchToApi(`api/notes/${id}`, {name});
        load();
    };

    const handleDelete = async (id) => {
        await deleteFromApi(`api/notes/entry/${id}`);
        load();
    };

    const filtered = search
        ? allNotes.filter(n => n.name.toLowerCase().includes(search.toLowerCase()))
        : allNotes;

    return (
        <div>
            <div className="page-header d-flex align-items-center justify-content-between">
                <h4><i className="bi bi-journal-text me-2" style={{color:"#6366f1"}}/>Notes</h4>
            </div>

            <div className="panel mb-4">
                <AddNoteFolder onSubmit={load} />
            </div>

            <div className="mb-3">
                <input
                    className="form-control"
                    placeholder="Search folders..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                />
            </div>

            <div className="row g-3">
                {filtered.map(note => (
                    <div key={note._id} className="col-sm-6 col-md-4 col-lg-3">
                        <div className="panel d-flex flex-column gap-2" style={{padding:"1rem"}}>
                            <div className="d-flex align-items-center gap-2">
                                <div className="stat-card-icon flex-shrink-0" style={{background:"#eef2ff",color:"#6366f1",width:36,height:36,fontSize:"1rem"}}>
                                    <i className="bi bi-journal-text"/>
                                </div>
                                <div className="flex-grow-1 min-w-0">
                                    <InlineRename value={note.name} onSave={name => handleRename(note._id, name)} className="fw-medium" />
                                    <div className="small text-muted">{note.entryCount || 0} note{note.entryCount !== 1 ? "s" : ""}</div>
                                </div>
                            </div>
                            <div className="d-flex gap-2 mt-1">
                                <Link to={`/notes/${note._id}`} className="btn btn-sm btn-dark flex-grow-1">Open</Link>
                                <ConfirmButton className="btn btn-sm btn-outline-danger" onConfirm={() => handleDelete(note._id)}>
                                    <i className="bi bi-trash"/>
                                </ConfirmButton>
                            </div>
                        </div>
                    </div>
                ))}
                {!filtered.length && (
                    <div className="empty-state">
                        <i className="bi bi-journal-plus"/>
                        <div>{search ? "No folders match your search." : "No note folders yet."}</div>
                    </div>
                )}
            </div>
        </div>
    );
}
